var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "mb-3 pb-3 flex items-center gap-3 border-b border-slate-400"
    },
    [
      _c("div", { staticClass: "w-25 flex-shrink-0 rounded shadow-md" }, [
        _c(
          "div",
          {
            staticClass:
              "h-7 flex items-center justify-center rounded-t transition-all duration-300",
            class: [_vm.deleteState ? "bg-slate-200" : "bg-orange-200"]
          },
          [
            _c("BlTextBody2", {
              staticClass: "transition-all duration-300",
              class: [_vm.deleteState ? "text-slate-700" : "text-orange-700"],
              attrs: {
                text: _vm.isPattern
                  ? "Every"
                  : _vm.displayDate(_vm.timeslot.date, "dddd")
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "h-18 flex flex-col items-center justify-center rounded-b bg-pure-white"
          },
          [
            _c("BlTextTitle4", {
              staticClass: "transition-all duration-300",
              class: [_vm.deleteState ? "text-slate-700" : "text-orange-700"],
              attrs: {
                text: _vm.displayDate(
                  _vm.timeslot.date,
                  _vm.isPattern ? "ddd" : "DD"
                )
              }
            }),
            _vm._v(" "),
            !_vm.isPattern
              ? _c("BlTextBody2", {
                  staticClass: "transition-all duration-300",
                  class: [
                    _vm.deleteState ? "text-slate-600" : "text-orange-600"
                  ],
                  attrs: { text: _vm.displayDate(_vm.timeslot.date, "MMMM") }
                })
              : _vm._e()
          ],
          1
        )
      ]),
      _vm._v(" "),
      !_vm.deleteState
        ? _c(
            "div",
            {
              staticClass:
                "w-full py-3 px-3 flex flex-col gap-3 rounded transition-all duration-300",
              class: { "bg-tomato-100": _vm.unavailableTimeslot }
            },
            [
              _c(
                "div",
                { staticClass: "flex flex-col gap-1" },
                [
                  _c(
                    "div",
                    {
                      staticClass: "max-w-88 flex items-center gap-1",
                      attrs: { title: _vm.timeslot.user.name }
                    },
                    [
                      _c("BlTextBody2", {
                        class: [
                          _vm.unavailableTimeslot
                            ? "text-tomato-700"
                            : "text-slate-700"
                        ],
                        attrs: { text: "Therapist:" }
                      }),
                      _vm._v(" "),
                      _c("BlTextSubtitle3", {
                        staticClass: "truncate",
                        class: [
                          _vm.unavailableTimeslot
                            ? "text-tomato-700"
                            : "text-slate-700"
                        ],
                        attrs: { text: _vm.timeslot.user.name }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("BlTextTitle4", {
                    class: [
                      _vm.unavailableTimeslot
                        ? "text-tomato-700"
                        : "text-slate-800"
                    ],
                    attrs: {
                      text:
                        _vm.timeslot.start_time_string +
                        " - " +
                        _vm.timeslot.end_time_string
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "flex items-center gap-2" }, [
                _c(
                  "div",
                  { staticClass: "max-w-64 flex items-center gap-2 truncate" },
                  [
                    _vm.enableBranch && _vm.timeslot.room.branch
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "h-7 min-w-12 max-w-24 px-2 flex items-center justify-center rounded truncate",
                            style: {
                              backgroundColor:
                                _vm.timeslot.room.branch.background_color ||
                                "unset"
                            },
                            attrs: { title: _vm.timeslot.room.branch.name }
                          },
                          [
                            _c("BlTextBody2", {
                              staticClass: "truncate",
                              style: {
                                color: _vm.timeslot.room.branch.color || "unset"
                              },
                              attrs: {
                                text: _vm.timeslot.room.branch.name || "-"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "truncate",
                        attrs: { title: _vm.timeslot.room.name }
                      },
                      [
                        _c("BlTextBody2", {
                          staticClass: "truncate",
                          class: { "text-tomato-700": _vm.unavailableTimeslot },
                          attrs: { text: _vm.timeslot.room.name }
                        })
                      ],
                      1
                    )
                  ]
                ),
                _vm._v(" "),
                _c("div", {
                  staticClass: "w-1 h-1 flex-shrink-0 bg-slate-600 rounded",
                  class: [
                    _vm.unavailableTimeslot ? "bg-tomato-700" : "bg-slate-600"
                  ]
                }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "flex-shrink-0" },
                  [
                    _c("BlTextBody2", {
                      class: { "text-tomato-700": _vm.unavailableTimeslot },
                      attrs: { text: _vm.timeslotCount + " credit(s)" }
                    }),
                    _vm._v(" "),
                    _vm.timeslot.credit_transaction_services.length
                      ? _c("BlTextBody2", {
                          class: { "text-tomato-700": _vm.unavailableTimeslot },
                          attrs: {
                            text:
                              "of " +
                              _vm.timeslot.credit_transaction_services[0]
                                .package_item_name
                          }
                        })
                      : _vm._e()
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _vm.useStartsFrom
                ? _c("BlTextBody2", {
                    attrs: {
                      text:
                        "Starts from " +
                        _vm.displayDate(_vm.timeslot.date, "DD MMM YYYY")
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.isCreditItemUnavailable
                ? _c("div", { staticClass: "flex" }, [
                    _c(
                      "div",
                      { staticClass: "px-2 bg-tomato-100 rounded" },
                      [
                        _c("BlTextSubtitle3", {
                          staticClass: "text-tomato-700",
                          attrs: { text: "Selected credit item unavailable" }
                        })
                      ],
                      1
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.isTherapistUnavailable
                ? _c("div", { staticClass: "flex" }, [
                    _c(
                      "div",
                      { staticClass: "px-2 bg-tomato-100 rounded" },
                      [
                        _c("BlTextSubtitle3", {
                          staticClass: "text-tomato-700",
                          attrs: { text: "Therapist unavailable for open room" }
                        })
                      ],
                      1
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.isSelectedSlotUnavailable
                ? _c("div", { staticClass: "flex" }, [
                    _c(
                      "div",
                      { staticClass: "px-2 bg-tomato-100 rounded" },
                      [
                        _c("BlTextSubtitle3", {
                          staticClass: "text-tomato-700",
                          attrs: { text: "Selected slot unavailable" }
                        })
                      ],
                      1
                    )
                  ])
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.deleteState
        ? _c(
            "div",
            {
              staticClass: "py-3 flex flex-col items-center flex-shrink-0",
              class: [
                _vm.useStartsFrom ? "h-38" : "h-30",
                _vm.useEdit ? "justify-between" : "justify-center"
              ]
            },
            [
              _c("BlInputButton", {
                attrs: {
                  type: "outlined",
                  icon: "delete",
                  dense: "",
                  disabled: _vm.deleteDisabled
                },
                on: {
                  clicked: function($event) {
                    _vm.deleteState = true
                  }
                }
              }),
              _vm._v(" "),
              _vm.useEdit
                ? _c("BlInputButton", {
                    attrs: { type: "outlined", icon: "edit", dense: "" },
                    on: {
                      clicked: function($event) {
                        return _vm.$emit("edit")
                      }
                    }
                  })
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.deleteState
        ? _c(
            "div",
            {
              staticClass:
                "w-full py-4 px-3 flex items-center justify-between rounded bg-slate-200"
            },
            [
              _c("BlTextBody2", {
                attrs: { text: "You have deleted this appointment." }
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "flex items-center gap-2" },
                [
                  _c("div", { staticClass: "blum-loader-btn" }),
                  _vm._v(" "),
                  _c("BlInputButton", {
                    attrs: {
                      type: "outlined",
                      label: "Undo deletion",
                      dense: ""
                    },
                    on: {
                      clicked: function($event) {
                        _vm.deleteState = false
                      }
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7b81d498", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7b81d498","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/appointments/overlay/ItemTimeslot.vue
// module id = null
// module chunks = 